let ChallengeDetailData = {
  title: "Design a Dashboard for Sokofund",
  date: "2024-12-24",
  prize: "$150",
  duration: "7days",
  contact: "talent@umurava.africa",
  projectBrief:
    " A Fintech company that is developing a Digital Financial Platformdesigned for businesses and their workforce in Africa is partnering with Umurava to run a Skills Challenge for Product Design. This Fintech Company offers a Payroll Management System to Employers and Embedded Financial services and products to Employees and Gig Workers across Africa",
  projectDescription:
    "User Interface Design for each step.Creating wireframes to outline the basic structure and layout of the web and mobile app.Designing visually appealing and user-friendly interfaces for the web and mobile apps focusing on usability and user experience.Ensuring the web application works seamlessly across web, mobile, and tablet devices.Provide a feedback session for in-development guidance.",
  projectRequirement:
    "UX research to understand Project Requirements.Understanding User Needs.Understanding Business Goals.Determine interaction between users.Requirements Catalog",
  deliverables:
    "The Product Designer will provide all documents and deliverables to the client before the review meetings.The Product Designer will provide all documents and deliverables to the client before the review meetings",
};
export default ChallengeDetailData;
export const adminChallengeDetailData = [
  {
    id: "1",
    date: "2024-12-24",
    prize: "$150",
    duration: "7days",
    contact: "talent@umurava.africa",
    title: "Design a Dashboard for Sokofund",
    projectBrief:
      " A Fintech company that is developing a Digital Financial Platformdesigned for businesses and their workforce in Africa is partnering with Umurava to run a Skills Challenge for Product Design. This Fintech Company offers a Payroll Management System to Employers and Embedded Financial services and products to Employees and Gig Workers across Africa",
    projectDescription:
      "User Interface Design for each step.Creating wireframes to outline the basic structure and layout of the web and mobile app.Designing visually appealing and user-friendly interfaces for the web and mobile apps focusing on usability and user experience.Ensuring the web application works seamlessly across web, mobile, and tablet devices.Provide a feedback session for in-development guidance",
    projectRequirement:
      "UX research to understand Project Requirements.Understanding User Needs.Understanding Business Goals.Determine interaction between users.Requirements Catalog",
    deliverables:
      "The Product Designer will provide all documents and deliverables to the client before the review meetings.The Product Designer will provide all documents and deliverables to the client before the review meetings",
    imageUrl: "images/dsd-copy.jpg",
  },
  {
    id: "2",
    date: "2024-12-24",
    prize: "$150",
    duration: "7days",
    contact: "talent@umurava.africa",
    title: "Build an E-commerce Platform",
    projectBrief: "Develop an online store...",
    projectDescription:
      "User Interface Design for each step.Creating wireframes to outline the basic structure and layout of the web and mobile app.Designing visually appealing and user-friendly interfaces for the web and mobile apps focusing on usability and user experience.Ensuring the web application works seamlessly across web, mobile, and tablet devices.Provide a feedback session for in-development guidance.",
    projectRequirement:
      "UX research to understand Project Requirements.Understanding User Needs.Understanding Business Goals.Determine interaction between users.Requirements Catalog",
    deliverables:
      "The Product Designer will provide all documents and deliverables to the client before the review meetings.The Product Designer will provide all documents and deliverables to the client before the review meetings",
    imageUrl: "images/dsd.jpg",
  },
];
